export const transformPhoneNumber = (phoneNumber: string): string => {
  const phoneNumberRegex = /^([\d][\d][\d]-[\d][\d][\d]-[\d][\d][\d][\d])$/
  if (phoneNumberRegex.test(phoneNumber)) {
    return phoneNumber
  }

  if (!phoneNumber) {
    return ''
  }

  phoneNumber = phoneNumber.replace(/-/g, '')

  if (isNaN(+phoneNumber)) {
    return ''
  }

  if (phoneNumber.length < 4) {
    return phoneNumber
  } else if (phoneNumber.length >= 4 && phoneNumber.length <= 6) {
    return phoneNumber.substring(0, 3) + '-' + phoneNumber.substring(3)
  } else {
    return phoneNumber.substring(0, 3) + '-' + phoneNumber.substring(3, 6) + '-' + phoneNumber.substring(6, 10)
  }
}

export const isValidPhoneNumber = (phoneNumber: string): boolean => {
  if (phoneNumber) {
    const phoneNumberRegex = /^([\d][\d][\d]-[\d][\d][\d]-[\d][\d][\d][\d])$/
    return phoneNumberRegex.test(phoneNumber)
  }
  return false
}
